import { getChartItemColor, getChartValueShare } from '../Chart.utils'

export function getChartDonutLegendItems({ colors, items, nameKey, total }) {
  return items.map((item, index) => ({
    color: getChartItemColor({ colors, index, item }),
    id: item.id ?? item[nameKey],
    label: `${item[nameKey]} (${item.value})`,
    value: `${getChartValueShare(item.value, total)}%`,
  }))
}
